import React  from "react";
import { faRightFromBracket , faHeadset,faAddressCard, faPenToSquare, faHome } from '@fortawesome/free-solid-svg-icons'
import NavIconButton from "./NavIconButton";
import { useAuth } from '../auth/AuthContext';
import { routePath } from "../routes/routePath";
import '../assets/styles/header.css'
import { faIdBadge } from "@fortawesome/free-regular-svg-icons";
 const Header=()=>{
  const {empLogout,userInfo} = useAuth();
  const size = window.innerWidth < 600? '1.2rem' : '2rem';
  const isEmpActive=userInfo?.isEmpActive;
  const empName=userInfo?.empName;
 const isEmpLeader = userInfo?.isLeader;
 
  return (
    <div className="header my-3 mx-3">
  <h2>{empName}</h2>

  <div className="nav-container d-flex align-items-center">
    
    {/* LEFT SIDE ICONS */}
    <div className="d-flex flex-grow-1 justify-content-around gap-3">
      <NavIconButton icon={faAddressCard} title="حسابي" to={routePath.profile} size={size}/>
      
      {isEmpActive === true || isEmpActive === "True" ? (
        <>
    {isEmpLeader === "True" || isEmpLeader === true ? (
            <NavIconButton
              icon={faIdBadge}
              title="قيادي"
              to={routePath.empPositionManagement}
              size={size}
            />
          ) : null}
          <NavIconButton icon={faPenToSquare} title="تقييم الاداء" to={routePath.employeeEvaluation} size={size}/>
        </>
      ) : (
        <>
          <NavIconButton icon={faPenToSquare} title="قيادي" size={size} disabled/>
          <NavIconButton icon={faPenToSquare} title="تقييم الاداء" size={size} disabled/>
        </>
      )}
    </div>

    {/* CENTER (HOME) */}
    <div className="d-flex justify-content-center flex-shrink-0" style={{ width: "80px" }}>
      <NavIconButton icon={faHome} title="الرئيسية" to={routePath.home} size={size}/>
    </div>

    {/* RIGHT SIDE ICONS */}
    <div className="d-flex flex-grow-1 justify-content-around gap-3">
      <NavIconButton icon={faHeadset} title="الدعم" to={routePath.support} size={size}/>
      <NavIconButton icon={faRightFromBracket} title="خروج" to={routePath.login} size={size} onClick={empLogout}/>
    </div>

  </div>
</div>
);
}

export default Header;